const backfaceFixed = (fixed) => {
  /**
   * 表示されているスクロールバーとの差分を計測し、背面固定時はその差分body要素に余白を生成する
   */
  const scrollbarWidth = window.innerWidth - document.body.clientWidth;
  document.body.style.paddingRight = fixed ? `${scrollbarWidth}px` : '';

  /**
   * スクロール位置を取得する要素を出力する(`html`or`body`)
   */
  const scrollingElement = () => {
    const browser = window.navigator.userAgent.toLowerCase();
    if ('scrollingElement' in document) return document.scrollingElement;
    if (browser.indexOf('webkit') > 0) return document.body;
    return document.documentElement;
  };

  /**
   * 変数にスクロール量を格納
   */
  const scrollY = fixed
    ? scrollingElement().scrollTop
    : parseInt(document.body.style.top || '0', 10);

  const scrollData = !fixed
    ? Number(document.documentElement.style.top.replace('px', ''))
    : null;

  /**
   * CSSで背面を固定
   */
  const styles = {
    height: '100vh',
    left: '0',
    overflow: 'hidden',
    position: 'fixed',
    top: `${scrollY * -1}px`,
    width: '100vw',
  };

  Object.keys(styles).forEach((key) => {
    document.documentElement.style[key] = fixed ? styles[key] : '';
  });

  /**
   * 背面固定解除時に元の位置にスクロールする
   */
  const sideNav = document.getElementById('j-side');
  if (fixed) {
    document.body.classList.add('is-modal');
    const headerHeight =
      document.getElementsByClassName('l-header').length > 0
        ? 0
        : document.getElementsByClassName('l-header')[0].offsetHeight;

    if (scrollY > headerHeight) {
      sideNav.classList.add('is-modal');
    }
  }
  if (!fixed) {
    document.body.classList.remove('is-modal');
    sideNav.classList.remove('is-modal');
    window.scrollTo(0, scrollData * -1);
  }
};

// export { backfaceFixed };

export default () => {
  // ----------------------------------------------------------
  // SmoothScroll
  // ----------------------------------------------------------
  const targetTriggerModal = $('.js-modal-trigger');
  const targetCloseModal = $('.js-modal__close');
  const targetBodyModal = $('.p-modal__body');
  const targetrModal = $('.js-modal');

  if (targetTriggerModal) {


    const open = (target) => {
      // 背面コンテンツのスクロールを無効にする
      //console.log(target.next());
      $(target).next().addClass('is-active');
      backfaceFixed(true);
    };

    const close = (target) => {
      // 背面コンテンツのスクロールの無効を解除する
      targetrModal.removeClass('is-active');
      backfaceFixed(false);
    };

    targetTriggerModal.on('click',function(){
      open(this);
    });

    targetCloseModal.on('click',function(){
      close(this);
    });

    targetBodyModal.on('click',function(e){
      
      if(!$(e.target).closest('.p-modal__inner').length) {
        $(this).removeClass('is-active');
        close(this);
      }
    });


  }
};
